import type { IconName } from '@raiadrogasil/pulso-icons'
import { Icon, type TIconProps } from '~/components/icon'
import type { ContentScopedProps } from '../../content.types'
import { DISPLAY_NAME, useContentContext } from '../../content'

interface IContentIconProps extends TIconProps {}

export function ContentIcon({ symbol, ...props }: IContentIconProps) {
  const { __scopeContent } = props as ContentScopedProps<IContentIconProps>

  const { size } = useContentContext(DISPLAY_NAME, __scopeContent)

  const renderIconSize = (): TIconProps['size'] => {
    return size === 'tiny' ? 'extra-small' : 'small'
  }

  const renderSymbolIcon = (): IconName => {
    if (!symbol) return 'rdicon-default'
    return symbol as IconName
  }

  return (
    <Icon
      symbol={renderSymbolIcon()}
      size={renderIconSize()}
      data-testid="content-icon"
      color="colorTextNeutralAlternative"
      {...props}
    />
  )
}
